// Owner: workflow-canvas (plan §9.33); split out by performance-closure (§10.2) so the route can
// validate its search without loading the list page (React Flow, dagre, cronstrue) on first paint.
import { z } from 'zod';
import { WORKFLOW_TABS } from '@dataroom/core/search-enums';

export const WORKFLOW_SORTS = ['name', 'status', 'runs', 'success', 'lastRun', 'owner'] as const;
export type WorkflowSort = (typeof WORKFLOW_SORTS)[number];
export const TRIGGER_FILTERS = ['record', 'schedule', 'webhook', 'form_submitted', 'manual'] as const;

export const WorkflowsSearchSchema = z.object({
  tab: z.enum(WORKFLOW_TABS).optional().catch(undefined),
  q: z.string().max(120).optional().catch(undefined),
  trigger: z.enum(TRIGGER_FILTERS).optional().catch(undefined),
  object: z.string().max(63).optional().catch(undefined),
  sort: z.enum(WORKFLOW_SORTS).optional().catch(undefined),
  dir: z.enum(['asc', 'desc']).optional().catch(undefined),
  /** Open the start sheet ("New automation") on a mode. */
  new: z.enum(['describe', 'trigger', 'template']).optional().catch(undefined),
});
export type WorkflowsSearch = z.infer<typeof WorkflowsSearchSchema>;

/**
 * The builder route's search (`/automations/$workflowId`): the tab, the selected step and the
 * parameter "Fix in editor" focuses. Components below the route read it with `readBuilderSearch`.
 */
export const BuilderSearchSchema = z.object({
  tab: z.enum(['editor', 'runs', 'versions', 'settings']).optional().catch(undefined),
  step: z.string().max(60).optional().catch(undefined),
  field: z.string().max(120).optional().catch(undefined),
});
export type BuilderSearch = z.infer<typeof BuilderSearchSchema>;

/** The builder's search out of the router's loosely typed search of the current route. */
export const readBuilderSearch = (search: unknown): BuilderSearch =>
  BuilderSearchSchema.catch({}).parse(search);
